module.exports = __webpack_public_path__ + "img/Terraform-Inspect-Small.1d0ab8a3.png";